import React from 'react';

import { TitleWithDescription, ReadOnlyInput } from '@infoods/lifebase-ui';
import { useFormContext } from 'react-hook-form';

import classes from './MeasurementDatesSection.module.scss';
import { FormFieldsGrid } from '../../../FormFieldsGrid/FormFieldsGrid';
import { getRenderDate } from '../../utils/getRenderDate';
import { ChallengeFormValues } from '../../../../../interfaces/ChallengeFormValues';

export const MeasurementDatesSection = () => {
  const { control } = useFormContext<ChallengeFormValues>();

  return (
    // VIEW mode hardcoded because all values are auto-calculated
    <FormFieldsGrid mode="VIEW">
      <TitleWithDescription
        title="Measurement Dates"
        titleFont="body-14-bold"
        description={
          <>
            Set the date ranges for initial scans and final scans.
            <br />
            Participants may do additional scans throughout the challenge, but they must
            have at least 2 scans.
          </>
        }
        className={classes.span2Rows}
      />
      <ReadOnlyInput
        control={control}
        name="importantDates.firstScanStartDate"
        label="Start Date of First Scan"
        renderValue={getRenderDate}
      />
      <ReadOnlyInput
        control={control}
        name="importantDates.firstScanEndDate"
        label="End Date of First Scan"
        renderValue={getRenderDate}
      />
      <ReadOnlyInput
        control={control}
        name="importantDates.lastScanStartDate"
        label="Start Date of Last Scan"
        renderValue={getRenderDate}
      />
      <ReadOnlyInput
        control={control}
        name="importantDates.lastScanEndDate"
        label="End Date of Last Scan"
        renderValue={getRenderDate}
      />
    </FormFieldsGrid>
  );
};
